import { useState } from "react";
import { Switch } from "@/components/ui/switch";

export const OpportunityMessage = () => {
  const [isRecruiter, setIsRecruiter] = useState(false);

  const talentSteps = [
    {
      image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158",
      title: "1 - Publica os teus Projetos e Ganha Visibilidade"
    },
    {
      image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c",
      title: "2 - Explora e Candidata-te a Oportunidades"
    },
    {
      image: "https://images.unsplash.com/photo-1605810230434-7631ac76ec81",
      title: "3 - Sê escolhido e Analisa a tua exposição ao mercado"
    }
  ];

  const recruiterSteps = [
    {
      image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40",
      title: "1 - Publica Oportunidades"
    },
    {
      image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf",
      title: "2 - Explora Portfolios de Talentos"
    },
    {
      image: "https://images.unsplash.com/photo-1551836022-deb4988cc6c0",
      title: "3 - Recebe Candidaturas e Selftapes"
    },
    {
      image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4",
      title: "4 - Contrata os Talentos sem burocracias"
    }
  ];

  const currentSteps = isRecruiter ? recruiterSteps : talentSteps;

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center space-y-6">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
            Cria tu as tuas chances de chegares onde queres
          </h2>
          <p className="text-lg text-gray-600">
            Quanto mais criares através do Sonho, maiores as chances de chegarem a ti oportunidades.
          </p>
          
          <div className="flex items-center justify-center gap-3">
            <span className={`text-sm font-medium ${!isRecruiter ? 'text-green-600' : 'text-gray-500'}`}>Talento</span>
            <Switch
              checked={isRecruiter}
              onCheckedChange={setIsRecruiter}
              className="bg-green-500 data-[state=checked]:bg-green-500 data-[state=unchecked]:bg-green-500"
            />
            <span className={`text-sm font-medium ${isRecruiter ? 'text-green-600' : 'text-gray-500'}`}>Recrutador</span>
          </div>

          <div className={`mt-12 grid grid-cols-1 ${isRecruiter ? 'md:grid-cols-4' : 'md:grid-cols-3'} gap-6`}>
            {currentSteps.map((step, index) => (
              <div 
                key={step.title}
                className="group relative overflow-hidden rounded-xl shadow-lg transition-all duration-500 hover:scale-105 animate-fade-in"
                style={{ animationDelay: `${index * 200}ms` }}
              >
                <img 
                  src={step.image}
                  alt={step.title}
                  className="w-full h-48 object-cover transform transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent">
                  <div className="absolute bottom-4 left-4 right-4 text-white">
                    <p className="font-semibold">{step.title}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};